import { useContent } from '@/hooks/useContent';
import { Container, WwProse } from '@/components';

export const ProgramPage = () => {
  const { program } = useContent();
  if (!program) return null;

  return (
    <div>
      <Container max={900}>
        <WwProse html={program} />
      </Container>
    </div>
  );
};
